import { api } from '@app:providers';
import { UseToastIntercept } from '@app:store';
import { OrderRequestDto } from 'providers/api/formulation-service/product-formulation.api';
import { StoreState } from 'store/store';
import { dateIsOlderThan } from 'utils';
import { ActionContext } from '../types';
import { OrderMutations } from './orders.reducer';

const actions: ActionContext<StoreState, OrderMutations> = {
  createOrder: async function ({ rootState }, payload: OrderRequestDto) {
    try {
      await api.productFormulation.submitProductionOrder({
        ...payload,
        locationId: rootState.location.id,
      });
    } catch (e) {
      throw new UseToastIntercept({
        title: `Error creating order.`,
        description: 'Your action did not succeed.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  },
  fetchPendingOrders: async function ({ mutate, rootState }, payload: { page?: number; limit?: number; forceRefresh?: boolean } = {}) {
    const state = rootState.orders;
    const page = payload.page !== undefined ? payload.page : state.page > -1 ? state.page : 0;
    const limit = payload.limit !== undefined ? payload.limit : state.limit;

    if (page == state.page && state.limit >= limit && !dateIsOlderThan(state.lastUpdated, 3, 'm') && !payload.forceRefresh) return;

    mutate(OrderMutations.START_LOADING);

    try {
      const response = await api.productionOrders.fetchList({
        page,
        limit,
        //showAll: false,
        //sort: [rootState.orders.sortedBy['createdAt'] === SortingModes.ASC ? SortingKeys.ORDER_DATE : SortingKeys.ORDER_DATE_DESC],
      });

      mutate(OrderMutations.SET_ORDERS, {
        items: response.data,
        page: response.page,
        limit,
        totalItems: response.totalItems,
      });
    } catch (e) {
      throw new Error('Error fetching pending products.');
    } finally {
      mutate(OrderMutations.STOP_LOADING);
    }
  },
  /*sortPendingOrders: async function ({ mutate, rootState }, payload: { by: keyof OrdersState['sortedBy']; mode: SortingModes }) {
    rootState.orders.sortedBy[payload.by] = payload.mode;
    await this.fetchPendingOrders({ mutate, rootState }, { forceRefresh: true });
    mutate(OrderMutations.SET_SORTING, { key: payload.by, sortMode: payload.mode });
  },
  deletePendingOrder: async function ({ mutate, rootState }, payload: { orderId: string; refresh: boolean }) {
    mutate(OrderMutations.START_LOADING);
    try {
      await api.orders.pending.delete({ params: { orderId: payload.orderId } });
      if (payload.refresh) await this.fetchPendingOrders({ mutate, rootState }, { forceRefresh: true });
    } catch (e) {
      throw new Error('Error deleting order.');
    } finally {
      mutate(OrderMutations.STOP_LOADING);
    }
  },*/
};

export default actions;
